import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import styled from 'styled-components';

import { makeNavOption, makeNavGroup } from './makeNav';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

const StyledTabs = styled(Tabs).attrs({
  variant: 'scrollable',
  scrollButtons: false,
  allowScrollButtonsMobile: false,
  textColor: 'inherit',
  'aria-label': 'Global navigation',
})`
  && {
    flex: 0 1 auto;
    min-height: var(--app-header-height);
    .MuiTabs-flexContainer {
      height: 100%;
    }
    .MuiTabs-indicator {
      height: 3px;
      background-color: ${COLORS.ctaPrimary};
    }
  }
`;

const StyledTab = styled(Tab)`
  && {
    min-height: var(--app-header-height);
    min-width: 0;
    padding: 0 16px;
    opacity: 1;
    color: ${COLORS.blackBase};
    font-size: 14px;
    font-weight: 600;
    text-transform: none;
    white-space: nowrap;
    &:hover {
      background-color: ${COLORS.greyLightest};
    }
    &.Mui-selected {
      color: ${COLORS.ctaPrimary};
      /* index.css sets a global !important on a.Mui-selected */
      background-color: ${COLORS.ctaPrimaryBackgroundLighter} !important;
    }
    &.Mui-focusVisible {
      outline: 2px solid ${COLORS.ctaPrimary};
      outline-offset: -2px;
    }
  }
`;

export const NavTab = makeNavOption(StyledTab);
const NavTabs = makeNavGroup(StyledTabs);
export default NavTabs;
